var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.40741,
    strokeWidth: 1.18519
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00002,
    cy: 8.00002,
    r: 4.02963,
    strokeWidth: 1.42222
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00696 3.40137L8.00696 0.734701",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39587 8.01147L0.729207 8.01148",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.74634 11.2722L2.86072 13.1578",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2673 11.272L13.153 13.1576",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00696 15.2893L8.00696 12.6226",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 8L12.618 8.01157",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1528 2.86572L11.2672 4.75134",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86108 2.86572L4.7467 4.75134",
    strokeWidth: 1.42222,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetting);
export default __webpack_public_path__ + "static/media/betting.86f31a0bcafee328fcf9eecaf8bb50b8.svg";
export { ForwardRef as ReactComponent };